// extracted by mini-css-extract-plugin
module.exports = {"header":"_927a99ad28--header--iQVYu","points_cell":"_927a99ad28--points_cell--t1lwv","points_hint":"_927a99ad28--points_hint--_HI1M"};